<template>
  <app-page :title="$t('absences.title')" :subtitle="$t('absences.subtitle')" icon="user-clock">
    <template v-slot:infobox>
      <sme-info-box :title="$t('absences.infoBox.aboutTitle')" id="about-absences" save-state>
        <p>{{ $t('absences.infoBox.aboutBody') }}</p>
        <p>
          <strong>{{ $t('absences.infoBox.experienceBold') }}</strong>
        </p>
      </sme-info-box>
      <sme-info-box :title="$t('absences.infoBox.addTitle')" id="adding-absences" save-state>
        <p>
          <i18n path="absences.infoBox.addIntegrationBody" tag="span">
            <template #link
              ><router-link :to="{ name: 'sme-integrations' }">{{
                $t('common.integrationLinkText')
              }}</router-link></template
            >
          </i18n>
        </p>
        <p v-if="canAddAbsences">
          <i18n path="absences.infoBox.addManualBody" tag="span">
            <template #link
              ><router-link :to="{ name: 'sftp-bulk-upload', query: { entity: 'absences' } }">{{
                $t('common.inBulkLinkText')
              }}</router-link></template
            >
          </i18n>
        </p>
      </sme-info-box>
      <sme-info-box :title="$t('absences.infoBox.editTitle')" id="editing-absences" save-state>
        <p v-if="canAddAbsences">{{ $t('absences.infoBox.editUploadedBody') }}</p>
        <p v-if="!canAddAbsences">
          {{ $t('absences.infoBox.editIntegratedBody', { absenceProvider: bankingInfo.absence.absenceProvider }) }}
        </p>
      </sme-info-box>
    </template>
    <template v-slot:header v-if="State.state.claims.a">
      <b-button
        v-if="canAddAbsences"
        :to="{ name: 'sftp-bulk-upload', query: { entity: 'absences' } }"
        variant="outline-primary"
      >
        <font-awesome-icon :icon="['fal', 'upload']" class="mr-2" /> {{ $t('common.bulkImportButton') }}
      </b-button>
    </template>

    <template v-slot:custom-content>
      <b-col>
        <b-card>
          <absences-list class="mt-3" />
        </b-card>
      </b-col>
    </template>
  </app-page>
</template>

<script setup>
import { computed } from 'vue';
import { getBankingInfo } from '@/Banking';
import AppPage from '@/components/AppPage.vue';
import SmeInfoBox from '@/components/atoms/SmeInfoBox.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import AbsencesList from '@/pages/absences/components/AbsencesList.vue';
import State from '@/state/State';

const { canAddAbsences } = useFeatureFlags();
const bankingInfo = computed(() => getBankingInfo());
</script>
